<template>
  <div style="margin:0 auto;">
      <ul>
        <li style="width:95%" v-for="obj in tableData">
          <span style="width:95%">{{ obj.title }}</span>
          <span style="width:5%">
            <el-button type="text" @click="getDetail(obj.id)"  icon="el-icon-arrow-right"></el-button>
          </span>  
        </li>       
      </ul>
      <el-pagination
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-size="pageSize"
                :total="totalPage"
                layout="pager">
        </el-pagination>

    
  </div>
</template>

<script>
  import axios from 'axios'
  import { Message } from 'element-ui'

  export default {
    data() {
      return {
        pageIndex: 1,
        pageSize: 20,
        totalPage: 0,
        tableData: [],
        loading: false,
        noMore: false
      };
    },
    created() {
      this.getDataList()
    },
    methods: {
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      getDataList() {
        this.loading = true
        this.setAxiosHeader()
        const getTimestamp = new Date().getTime()
        axios.post(`/commonproblem/list?timer=${getTimestamp}`, {
            current: this.pageIndex,
            size: this.pageSize
        }).then(res => {
            console.log(res.data)
            if(res.data.respCode == "0000") {
              this.tableData = res.data.data.records
              this.totalPage = res.data.data.total
            } else {
              console.log(res.data.errMsg)
              Message({
                message: res.data.errMsg,
                type: 'error'
              })
            }
        }).catch(err => {
            Message({
              message: err,
              type: 'error'
            })
        })
      },
      setAxiosHeader() {
        axios.defaults.withCredentials = false;
        axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头
      },
      getDetail(id) {
        console.log("getDetail>>>",id)
        this.$router.push({path:'/detail',query: {id: id}})
      }
    }
  }
</script>

<style>

li {
  list-style-type:none;
  height: 50px;
  text-align: left;
}
ul {
  margin: 0 auto
}

</style>


// WEBPACK FOOTER //
// src/components/CommonProblem.vue